export enum Path {
  ACTIVATE = 'activate',
  AUTHENTICATE = 'authenticate',
  AUTHORIZE = 'authorize',
  GEO_FENCE = 'unavailable',
  GO = 'go',
  LOGIN = 'login',
  LINK = 'link',
  PLAYER = 'player',
  SIGNUP = 'signup',
  SUBSCRIBE = 'subscribe',
}

export const DynamicPath = {
  ACTIVATE: `/${Path.GO}/${Path.ACTIVATE}/:activationCode?`,
  CANONICAL: `/${Path.PLAYER}/:${Path.PLAYER}?/:assetType/:assetId`,
  GO: `/${Path.GO}/:launchCode`,
} as const;
